import { Box, useTheme, useMediaQuery } from '@mui/material';
import MyImage from '../../images/Lightbackground.png';
import Mobilebg from '../../images/Mobilebg.png';
import TypewriterText from './TypewriterText';

const HeroSection = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery('(min-width: 768px) and (max-width: 1024px)'); // iPad screen size range

    return (
        <Box
            sx={{
                height: isMobile ? '90vh' :  isTablet ? '100vh' : '100vh', // Adjusted height for tablet (iPad)
                backgroundImage: isMobile || isTablet ? `url(${Mobilebg})` : `url(${MyImage})`,
                backgroundSize: 'cover',
                backgroundPosition: isMobile || isTablet ? '75% center' : '0% center',
                position: 'relative',
                color: 'white',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
            }}
        >
            <Box sx={{
                position: 'absolute',
                bottom: isMobile || isTablet ? '5%'  : '35%', // Adjusted position for tablet (iPad)
                left: isMobile || isTablet ? '50%' : '12%',
                transform: isMobile || isTablet ? 'translate(-50%, 0)' : 'translateY(-50%)',
                width: isMobile || isTablet ? '100%' : 'auto',
                textAlign: isMobile  || isTablet ? 'center' : 'left',
            }}>
                <TypewriterText
                    lines={[
                        { text: "Hello, I am", style: { color: 'black', fontWeight: '300', fontSize: isMobile ? '18px' : isTablet ? '20px' : '35px' } },
                        { text: "Anand Somnath Pandey", style: { color: '#f9004d', fontWeight: '600', fontSize: isMobile ? '22px' : isTablet ? '30px' : '50px' } },
                        { text: "Student At Northeastern University", style: { color: 'black', fontWeight: '300', fontSize: isMobile ? '18px' : isTablet ? '20px' : '35px' } }
                    ]}
                />
            </Box>
        </Box>
    );
};

export default HeroSection;
